export const OCCURS_ONCE = "OccursOnce";
export const REPEATS_DAILY = "RepeatsDaily";
